export interface OrganisationLevel {
  id: string
  name: string
  key: string
  parentLevel?: string
  levelType: string
  usersCount: number
}

export const getKnownParentLevelId = (level: OrganisationLevel, levelIds: Set<string>) => (
  level.parentLevel && levelIds.has(level.parentLevel) ? level.parentLevel : null
)